export default {
  copySuccess: 'Value has been copied to clipboard',
  copyError: 'Value hasn\'t been copied to clipboard. Something went wrong...',
};
